import React, { useMemo } from "react";
import { ConfigProps } from "../../constants/configProps";
import { isYesOrTrue } from "../../utilities/utilities";

interface IDivSafeZoneProps {
    id: string;
    className?: string;
    count?: number;
    configProps: Record<string, string>;
}

export const DivSafeZone = (props: IDivSafeZoneProps) => {
    const { count = 3, id, className, configProps } = props;
    const displayDivSafeZone = isYesOrTrue(
        configProps[ConfigProps.ActivateAdobeTargetDIVTagSafeZones]
    );
    const divSafeZoneIds = useMemo(() => {
        const ids: string[] = [];

        for (let i = 0; i < count; i++) {
            ids.push(`${id}-${i + 1}`);
        }

        return ids;
    }, [count, id]);
    return (
        <>
            {displayDivSafeZone && divSafeZoneIds.map((divSafeZoneId) => (
                <div
                    id={divSafeZoneId}
                    className={className}
                    key={divSafeZoneId}
                    // suppress hydration warnings because advertisements can alter the html before the app hydrates
                    suppressHydrationWarning
                    // dangerouslySetInnerHTML prevents hydration from clearing out advertisements
                    dangerouslySetInnerHTML={{ __html: "" }}
                ></div>
            ))}
        </>
    );
};